import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { swiperThumbsPswp } from './swiper'

let swiperThumbs = null

function initPhotoSwipe() {
  const galleries = document.querySelectorAll('[id^=gallery-]')

  if (!galleries && galleries.length < 0) return

  const lightbox = new PhotoSwipeLightbox({
    gallery: galleries,
    children: '.gallery__item',
    pswpModule: () => import(/* webpackIgnore: true */ 'https://unpkg.com/photoswipe')
  });
  lightbox.init();

  setTimeout(() => {
    gallery_images_size();
    window.addEventListener("resize", function(){
      gallery_images_size();
    });
    function gallery_images_size() {
      let galleryItems = document.querySelectorAll(".gallery__item");
      for (let item of galleryItems ) {
        item.dataset.pswpWidth = window.innerWidth * 0.9;
        item.dataset.pswpHeight = window.innerWidth * 0.9 / 1.78;
      }
    }
  }, 500);

  galleries.forEach((gallery, galleryIndex) => {
    const triggerBox = document.querySelector(`#trigger-gallery-box-${galleryIndex + 1}`)
    const triggers = triggerBox.querySelectorAll('.gallery-trigger')
    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', onTrigger.bind(null, galleryIndex + 1, index))
    })
  })

  function onTrigger(galleryIndex, slideIndex) {
    lightbox.loadAndOpen(slideIndex, {
      gallery: document.querySelector(`#gallery-${galleryIndex}`)
    })
  }

  lightbox.addFilter('itemData', (itemData, index) => {
    const videoUrl = itemData.element.dataset.videoUrl;
    if (videoUrl) {
      itemData.videoUrl = videoUrl;
    }
    return itemData;
  });

  lightbox.on('contentLoad', (event) => {
    const { content } = event;

    if (content.type === 'video') {
      event.preventDefault()
      setupVideo(content)
    }

  });

  function setupVideo(content) {
    content.element = document.createElement('div');
    content.element.className = 'pswp__video-container';

    const iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', '');
    iframe.src = content.data.videoUrl;
    content.element.appendChild(iframe);
  }

  lightbox.on('afterInit', () => {

    lightbox.pswp.element.addEventListener('mousemove', (e) => {
      const overcomePercent = 10
      const overcomePixels = window.innerHeight - (window.innerHeight * 10 / 100)
      const isOvercome = e.clientY >= overcomePixels

      if (isOvercome) {
        document.querySelector('.swiper.pswp_thumbs').classList.add('active')
      }
      else {
        document.querySelector('.swiper.pswp_thumbs').classList.remove('active')
      }
    })

    setThumbsHTML()
    swiperThumbs = swiperThumbsPswp()
  });

  lightbox.on('close', () => {
    swiperThumbs.destroy(true, true)
  });

  function setThumbsHTML() {
    const pswpElement = document.querySelector('.pswp');

    const thumb = document.createElement('div');
    thumb.className = "swiper pswp_thumbs"
    const thumbWrapper = document.createElement('div')
    thumbWrapper.className = "swiper-wrapper"

    thumb.appendChild(thumbWrapper);

    lightbox.pswp.options.dataSource.items.forEach((item, index) => {
      const slide = document.createElement('div');
      slide.className = "swiper-slide pswp_thumb"
      const img = document.createElement('img');
      img.src = item.href
      slide.appendChild(img);
      thumbWrapper.appendChild(slide);

      slide.addEventListener('click', () => {
        console.log('click')
        lightbox.pswp.goTo(index)
      })
    })

    pswpElement.appendChild(thumb);
  }

}

initPhotoSwipe()